var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"mr-auto"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.name)+" ")])]),_c('div',[_c('span',[_vm._v(" "+_vm._s(_vm.getValue(_vm.min))+" ")])]),_vm._m(0),_c('div',[_c('span',[_vm._v(" "+_vm._s(_vm.getValue(_vm.max))+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(" - ")])])
}]

export { render, staticRenderFns }